// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { SxProps } from '@mui/material';

export const containerSx: SxProps = { display: 'flex', flexDirection: 'row', height: '100%' };
export const mainContentSx: SxProps = {
  p: 2,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  overflow: 'auto',
};
